const href = window.location.href;
if (href.indexOf("niezbednik-pacjenta") > 0) {
  const hash = href.split("#")[1];
  if (hash !== undefined && hash !== "") {
    $("html, body").animate(
      {
        scrollTop: $("#" + id).offset().top - 20,
      },
      1400
    );
  }
}
